import { render } from "./EditDogDialog.vue?vue&type=template&id=dbd2e5bc"
import script from "./EditDogDialog.vue?vue&type=script&lang=js"
export * from "./EditDogDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__